import { ReactLenis } from "lenis/react";
import "lenis/dist/lenis.css";

export default function SmoothScroll() {
  return (
    <ReactLenis
      root
      options={{
        lerp: 0.1,
        smoothWheel: true,
        syncTouch: false,
      }}
    />
  );
}